module.exports = __webpack_public_path__ + "images/corillian.5569e0caa3cc7f4ff58ee0b80f323f3e.png";


//////////////////
// WEBPACK FOOTER
// ../src/client/assets/images/logos/corillian.png
// module id = 1016
// module chunks = 0